
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/developers/promotion-on-social-media",
      function () {
        return require("private-next-pages/products/developers/promotion-on-social-media.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/developers/promotion-on-social-media"])
      });
    }
  